import { render, staticRenderFns } from "./ganntTasks.vue?vue&type=template&id=d407cb42&"
import script from "./ganntTasks.vue?vue&type=script&lang=js&"
export * from "./ganntTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports